// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3ClPk","error":"Textarea_error__2_pRR","readonly":"Textarea_readonly__17StC","disabled":"Textarea_disabled__39QOm"};